import React, {useEffect, useState} from "react";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {TextField} from "@mui/material";
import {useNavigate, useSearchParams} from 'react-router-dom';
import "../oneShot/OneShot.css";
import useMediaQuery from '@mui/material/useMediaQuery';
import {useTheme} from '@mui/material/styles';
import {getCookie, setCookie} from '../../utils/Functions';

import bgStadium from "../../assets/imgs/unicef/messi/bg-stadium.png";
import jerseyFramed from "../../assets/imgs/unicef/messi/jersey-framed.png";
import ticketOutline from "../../assets/imgs/unicef/messi/ticket-outline.png";
import sorteoLabel from "../../assets/imgs/unicef/messi/sorteo-label.png";
import iconSmile from "../../assets/imgs/unicef/messi/icon-smile.png";
import iconTshirt from "../../assets/imgs/unicef/messi/icon-tshirt.png";

const TicketCard = ({num, label, price, selected, onClick, isCustom, mobile, md}) => {
    const iconSize = mobile ? '36px' : (md ? '44px' : '52px');
    const numSize = mobile ? '18px' : (md ? '22px' : '26px');
    const labelSize = mobile ? '10px' : (md ? '12px' : '14px');
    const priceSize = mobile ? '10px' : (md ? '12px' : '14px');

    return (
        <div
            onClick={onClick}
            style={{
                border: selected ? '2px solid #fff' : '2px solid rgba(255,255,255,0.35)',
                borderRadius: '12px',
                padding: mobile ? '8px 2px' : (md ? '10px 6px' : '12px 8px'),
                textAlign: 'center',
                cursor: 'pointer',
                backgroundColor: 'transparent',
                transition: 'all 0.15s ease',
                flex: '1 1 0',
                minWidth: 0,
            }}
        >
            <div style={{
                position: 'relative',
                width: iconSize,
                height: iconSize,
                margin: '0 auto 4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <img src={ticketOutline} alt="" style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                }}/>
                <span style={{
                    position: 'absolute',
                    color: '#fff',
                    fontSize: numSize,
                    fontWeight: 'bold',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                }} className="font-face-UniversBold">
                    {isCustom ? '+' : num}
                </span>
            </div>
            <div style={{
                color: '#fff',
                fontSize: labelSize,
                marginBottom: '6px',
            }}>
                {label}
            </div>
            <div style={{
                backgroundColor: 'rgba(10,40,80,0.7)',
                borderRadius: '20px',
                padding: mobile ? '2px 6px' : '3px 10px',
                display: 'inline-block',
                border: '1px solid rgba(255,255,255,0.2)'
            }}>
                <span style={{
                    color: '#FFFA2F',
                    fontSize: priceSize,
                    fontWeight: 'bold',
                }} className="font-face-UniversBold">
                    {price}
                </span>
            </div>
        </div>
    );
};

const LaPoleraDeMessi = (props) => {

    const navigate = useNavigate();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const mdScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [showAmount, setShowAmount] = useState(false);
    const [error, setError] = useState("");
    const [amount, setAmount] = useState(150);
    const [tickets, setTickets] = useState(3);
    const [searchParams] = useSearchParams();

    const [finalData, setFinalData] = useState({
        utm_source: searchParams.get("utm_source") ? searchParams.get("utm_source") : "false",
        utm_medium: searchParams.get("utm_medium") ? searchParams.get("utm_medium") : "false",
        utm_campaign: searchParams.get("utm_campaign") ? searchParams.get("utm_campaign") : "false",
        utm_id: searchParams.get("utm_id") ? searchParams.get("utm_id") : "false",
        utm_term: searchParams.get("utm_term") ? searchParams.get("utm_term") : "false",
        utm_content: searchParams.get("utm_content") ? searchParams.get("utm_content") : "false"
    })

    const handleChange = (event) => {
        if (event.target.value === "") {
            setTickets(0)
            setAmount(0)
        } else {
            if (/^[0-9]+$/.test(event.target.value)) {
                setError("")
                const val = parseInt(event.target.value)
                setTickets(val)
                setAmount(val * 50)
                if (event.key === 'Enter') {
                    donate()
                }
            }
        }
    };

    const selectTickets = (numTickets) => {
        setError("");
        const newAmount = numTickets * 50;
        setTickets(numTickets);
        setAmount(newAmount);
        setShowAmount(false);

        if (fullScreen) {
            setTimeout(() => {
                const btn = document.getElementById('dona-ahora-btn');
                if (btn) {
                    btn.scrollIntoView({behavior: 'smooth', block: 'end'});
                }
            }, 100);
        }
    };

    const donate = () => {
        const currentAmount = parseInt(amount);
        if (currentAmount >= 50) {
            if (process.env.REACT_APP_URL_CONFIG === "https://www.unicef.org.bo") {
                window.fbq('track', 'AddToCart', {
                    content_type: 'product',
                    value: currentAmount,
                    currency: "BOB"
                });
                window.gtag("event", "add_to_cart", {
                    currency: "BOB",
                    value: currentAmount,
                    items: [
                        {
                            item_id: "SKU_DONACION",
                            item_name: "Donación de " + currentAmount + "Bs",
                            price: currentAmount,
                            quantity: 1
                        }
                    ]
                });
            }

            setTimeout(() => {
                window.scrollTo(0, 0)
            }, 100);
            navigate("/completar-lapolerademessi/" + currentAmount);
        } else {
            setError("El monto mínimo es Bs 50")
        }
    }

    useEffect(() => {
        let utm_source = ""
        let utm_id = ""
        let utm_content = ""
        let utm_medium = ""
        let utm_campaign = ""
        let utm_term = ""
        let _finalData = finalData

        if (searchParams.get("utm_source")) {
            utm_source = searchParams.get("utm_source")
            _finalData["utm_source"] = utm_source
        } else {
            utm_source = getCookie(process.env.REACT_APP_NAME + "utm_source")
            if (!utm_source || utm_source === "undefined" || utm_source === undefined || utm_source === null || utm_source === "null") {
                utm_source = ""
            }
            _finalData["utm_source"] = utm_source
        }

        if (searchParams.get("utm_term")) {
            _finalData["utm_term"] = utm_term
            utm_term = searchParams.get("utm_term")
        } else {
            utm_term = getCookie(process.env.REACT_APP_NAME + "utm_term")
            if (!utm_term || utm_term === "undefined" || utm_term === undefined || utm_term === null || utm_term === "null") {
                utm_term = ""
            }
            utm_term = searchParams.get("utm_term")
        }

        if (searchParams.get("utm_id")) {
            utm_id = searchParams.get("utm_id")
            _finalData["utm_id"] = utm_id
        } else {
            utm_id = getCookie(process.env.REACT_APP_NAME + "utm_id")
            if (!utm_id || utm_id === "undefined" || utm_id === undefined || utm_id === null || utm_id === "null") {
                utm_id = ""
            }
            _finalData["utm_id"] = utm_id
        }

        if (searchParams.get("utm_content")) {
            utm_content = searchParams.get("utm_content")
            _finalData["utm_content"] = utm_content
        } else {
            utm_content = getCookie(process.env.REACT_APP_NAME + "utm_content")
            if (!utm_content || utm_content === "undefined" || utm_content === undefined || utm_content === null || utm_content === "null") {
                utm_content = ""
            }
            _finalData["utm_content"] = utm_content
        }

        if (searchParams.get("utm_medium")) {
            utm_medium = searchParams.get("utm_medium")
            _finalData["utm_medium"] = utm_medium
        } else {
            utm_medium = getCookie(process.env.REACT_APP_NAME + "utm_medium")
            if (!utm_medium || utm_medium === "undefined" || utm_medium === undefined || utm_medium === null || utm_medium === "null") {
                utm_medium = ""
            }
            _finalData["utm_medium"] = utm_medium
        }

        if (searchParams.get("utm_campaign")) {
            utm_campaign = searchParams.get("utm_campaign")
            _finalData["utm_campaign"] = utm_campaign
        } else {
            utm_campaign = getCookie(process.env.REACT_APP_NAME + "utm_campaign")
            if (!utm_campaign || utm_campaign === "undefined" || utm_campaign === undefined || utm_campaign === null || utm_campaign === "null") {
                utm_campaign = ""
            }
            _finalData["utm_campaign"] = utm_campaign
        }

        setTimeout(() => {
            setFinalData(_finalData)
        }, 100);

        setCookie(process.env.REACT_APP_NAME + "utm_source", utm_source, 0.5)
        setCookie(process.env.REACT_APP_NAME + "utm_id", utm_id, 0.5)
        setCookie(process.env.REACT_APP_NAME + "utm_content", utm_content, 0.5)
        setCookie(process.env.REACT_APP_NAME + "utm_medium", utm_medium, 0.5)
        setCookie(process.env.REACT_APP_NAME + "utm_campaign", utm_campaign, 0.5)
        setCookie(process.env.REACT_APP_NAME + "utm_term", utm_term, 0.5)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const SorteoBadge = ({size = 'desktop'}) => {
        const isSmall = size === 'mobile';
        return (
            <div style={{
                backgroundColor: '#fff',
                borderRadius: '10px',
                padding: isSmall ? '8px 10px' : '12px 16px',
                textAlign: 'center',
                boxShadow: '0 4px 20px rgba(0,0,0,0.25)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: isSmall ? '110px' : '140px',
            }}>
                <img src={sorteoLabel} alt="Sorteo" style={{
                    width: isSmall ? '80px' : '110px',
                    marginBottom: isSmall ? '4px' : '8px',
                }}/>
                <p style={{
                    margin: 0,
                    fontSize: isSmall ? '10px' : '13px',
                    color: '#333',
                    lineHeight: 1.3,
                    fontWeight: '500'
                }}>
                    Polera oficial<br/>
                    FC Barcelona<br/>
                    <strong style={{color: '#29ABE2'}}>firmada por<br/>Lionel Messi</strong>
                </p>
            </div>
        );
    };

    return (
        <>
            {/* DESKTOP */}
            {!fullScreen && (
                <section style={{
                    backgroundImage: `url(${bgStadium})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    width: '100%',
                    minHeight: '90vh',
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    padding: mdScreen ? '50px 4%' : '60px 6%',
                    paddingBottom: '70px',
                }}>
                    <div style={{
                        display: 'flex',
                        width: '100%',
                        maxWidth: '1300px',
                        margin: '0 auto',
                        alignItems: 'center',
                        gap: mdScreen ? '20px' : '50px',
                    }}>
                        {/* Left Content */}
                        <div style={{flex: '1 1 55%'}}>
                            <h1 style={{
                                color: '#ffffff',
                                fontSize: mdScreen ? '2.4rem' : '3.5rem',
                                fontWeight: 'bold',
                                lineHeight: 1.05,
                                margin: '0 0 4px 0',
                            }} className="font-face-UniversBold">
                                CUANDO JUEGAS<br/>POR LA INFANCIA,
                            </h1>
                            <h1 style={{
                                color: '#FFFA2F',
                                fontSize: mdScreen ? '2.4rem' : '3.5rem',
                                fontWeight: 'bold',
                                lineHeight: 1.05,
                                margin: '0 0 24px 0',
                            }} className="font-face-UniversBold">
                                TODOS GANAN.
                            </h1>

                            <p style={{
                                color: '#ffffff',
                                fontSize: mdScreen ? '1.1rem' : '1.4rem',
                                fontWeight: 'bold',
                                margin: '0 0 4px 0'
                            }} className="font-face-UniversBold">
                                Selecciona tus tickets
                            </p>
                            <p style={{
                                color: '#ffffff',
                                fontSize: mdScreen ? '0.9rem' : '1rem',
                                margin: '0 0 16px 0'
                            }}>
                                Cada ticket equivale a <strong style={{color: '#FFFA2F'}}>50 Bs.</strong>
                            </p>

                            {/* Ticket Cards */}
                            <div style={{
                                display: 'flex',
                                gap: mdScreen ? '8px' : '12px',
                                marginBottom: '12px',
                                maxWidth: '540px',
                            }}>
                                <TicketCard
                                    num="1" label="Ticket" price="Bs. 50"
                                    selected={tickets === 1 && !showAmount}
                                    onClick={() => selectTickets(1)}
                                    md={mdScreen}
                                />
                                <TicketCard
                                    num="3" label="Tickets" price="Bs. 150"
                                    selected={tickets === 3 && !showAmount}
                                    onClick={() => selectTickets(3)}
                                    md={mdScreen}
                                />
                                <TicketCard
                                    num="5" label="Tickets" price="Bs. 250"
                                    selected={tickets === 5 && !showAmount}
                                    onClick={() => selectTickets(5)}
                                    md={mdScreen}
                                />
                                <TicketCard
                                    num="+" label="Tickets" price="Tú eliges"
                                    selected={showAmount}
                                    isCustom={true}
                                    onClick={() => {
                                        setShowAmount(true);
                                        setAmount(250);
                                        setTickets(5);
                                    }}
                                    md={mdScreen}
                                />
                            </div>

                            <p style={{
                                color: '#ffffff',
                                fontSize: mdScreen ? '0.75rem' : '0.85rem',
                                margin: '0 0 20px 0',
                            }}>
                                * Por cada <strong>Bs 50</strong> donados recibes una oportunidad más para participar en el <strong>SORTEO.</strong>
                            </p>

                            {showAmount && (
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    marginBottom: '18px',
                                }}>
                                    <TextField
                                        value={tickets || ''}
                                        onChange={handleChange}
                                        onKeyDown={handleChange}
                                        placeholder="Nº tickets"
                                        variant="outlined"
                                        size="small"
                                        sx={{
                                            width: '130px',
                                            '& .MuiOutlinedInput-root': {
                                                color: '#fff',
                                                backgroundColor: 'rgba(0,0,0,0.3)',
                                                '& fieldset': {borderColor: 'rgba(255,255,255,0.5)'},
                                                '&:hover fieldset': {borderColor: '#fff'},
                                                '&.Mui-focused fieldset': {borderColor: '#FFFA2F'},
                                            },
                                            '& .MuiInputBase-input': {color: '#fff', fontSize: '1rem'}
                                        }}
                                    />
                                    <span style={{color: '#fff', fontSize: '0.9rem'}}>
                                        ticket{tickets !== 1 ? 's' : ''} = <strong style={{color: '#FFFA2F'}}>Bs. {amount}</strong>
                                    </span>
                                </div>
                            )}

                            {/* Dona Ahora + Info Box */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: mdScreen ? '16px' : '24px',
                            }}>
                                <button
                                    onClick={donate}
                                    style={{
                                        backgroundColor: '#FFFA2F',
                                        color: '#000',
                                        border: 'none',
                                        borderRadius: '8px',
                                        padding: mdScreen ? '14px 28px' : '18px 40px',
                                        fontSize: mdScreen ? '1.3rem' : '1.7rem',
                                        fontWeight: 'bold',
                                        cursor: 'pointer',
                                        textTransform: 'uppercase',
                                        whiteSpace: 'nowrap',
                                        flexShrink: 0,
                                    }}
                                    className="font-face-UniversBold"
                                >
                                    DONA AHORA
                                </button>

                                <div style={{
                                    border: '1px solid rgba(255,255,255,0.3)',
                                    borderRadius: '12px',
                                    padding: mdScreen ? '12px 14px' : '16px 20px',
                                    flex: '1',
                                    maxWidth: '380px'
                                }}>
                                    <p style={{
                                        color: '#fff',
                                        fontSize: mdScreen ? '0.8rem' : '0.9rem',
                                        fontWeight: 'bold',
                                        margin: '0 0 8px 0'
                                    }} className="font-face-UniversBold">
                                        CON TU DONACIÓN:
                                    </p>
                                    <div style={{display: 'flex', alignItems: 'flex-start', gap: '8px', marginBottom: '6px'}}>
                                        <img src={iconSmile} alt="" style={{width: '18px', flexShrink: 0, marginTop: '2px'}}/>
                                        <span style={{color: '#fff', fontSize: mdScreen ? '0.72rem' : '0.82rem', lineHeight: 1.4}}>
                                            Cambias la vida de miles de niñas y niños y como agradecimiento por tu solidaridad,
                                        </span>
                                    </div>
                                    <div style={{display: 'flex', alignItems: 'flex-start', gap: '8px'}}>
                                        <img src={iconTshirt} alt="" style={{width: '18px', flexShrink: 0, marginTop: '2px'}}/>
                                        <span style={{color: '#fff', fontSize: mdScreen ? '0.72rem' : '0.82rem', lineHeight: 1.4}}>
                                            Participas del <strong style={{color: '#29ABE2'}}>SORTEO</strong> de una polera oficial del FC Barcelona firmada por Lionel Messi. <em>Incluye el certificado de autenticidad.</em>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {error !== "" && (
                                <div style={{
                                    background: "#000",
                                    fontSize: "0.9rem",
                                    fontWeight: 600,
                                    textAlign: "center",
                                    color: "#fff",
                                    padding: '8px 16px',
                                    borderRadius: 5,
                                    marginTop: '12px',
                                    display: 'inline-block'
                                }}>
                                    <WarningAmberIcon sx={{fontSize: "1.4rem", marginRight: 1, verticalAlign: 'middle'}}/>
                                    {error}
                                </div>
                            )}
                        </div>

                        {/* Right Content - Jersey + Sorteo Badge */}
                        <div style={{
                            flex: '0 0 38%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'relative'
                        }}>
                            <img
                                src={jerseyFramed}
                                alt="Polera de Messi firmada"
                                style={{
                                    width: '100%',
                                    maxWidth: mdScreen ? '260px' : '340px',
                                    height: 'auto'
                                }}
                            />
                            <div style={{
                                position: 'absolute',
                                bottom: '10%',
                                right: mdScreen ? '-12%' : '-15%',
                            }}>
                                <SorteoBadge size="desktop" />
                            </div>
                        </div>
                    </div>

                    {/* Bottom bar */}
                    <div style={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        backgroundColor: 'rgba(0,0,0,0.55)',
                        padding: '10px 20px',
                        textAlign: 'center'
                    }}>
                        <p style={{
                            color: '#fff',
                            fontSize: mdScreen ? '0.8rem' : '0.9rem',
                            margin: 0
                        }}>
                            El sorteo se realizará en la Teletón de UNICEF el <strong style={{color: '#FFFA2F'}}>domingo 20 de septiembre</strong> que será transmitido a nivel nacional por Red Uno.
                        </p>
                    </div>
                </section>
            )}

            {/* MOBILE */}
            {fullScreen && (
                <section style={{
                    backgroundImage: `linear-gradient(rgba(0,0,20,0.55), rgba(0,0,20,0.55)), url(${bgStadium})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'right center',
                    width: '100%',
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '20px 16px 70px',
                }}>
                    <h1 style={{
                        color: '#ffffff',
                        fontSize: '1.7rem',
                        fontWeight: 'bold',
                        lineHeight: 1.05,
                        margin: '0 0 2px 0',
                    }} className="font-face-UniversBold">
                        CUANDO JUEGAS<br/>POR LA INFANCIA,
                    </h1>
                    <h1 style={{
                        color: '#FFFA2F',
                        fontSize: '1.7rem',
                        fontWeight: 'bold',
                        lineHeight: 1.05,
                        margin: '0 0 16px 0',
                    }} className="font-face-UniversBold">
                        TODOS GANAN.
                    </h1>

                    {/* Jersey + Badge mobile */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'flex-end',
                        marginBottom: '16px',
                        position: 'relative',
                        padding: '0 10px',
                    }}>
                        <img
                            src={jerseyFramed}
                            alt="Polera de Messi firmada"
                            style={{
                                width: '50%',
                                maxWidth: '180px',
                                height: 'auto'
                            }}
                        />
                        <div style={{
                            position: 'absolute',
                            bottom: '5%',
                            right: '8%',
                        }}>
                            <SorteoBadge size="mobile" />
                        </div>
                    </div>

                    <p style={{
                        color: '#ffffff',
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        margin: '0 0 2px 0'
                    }} className="font-face-UniversBold">
                        Selecciona tus tickets
                    </p>
                    <p style={{
                        color: '#ffffff',
                        fontSize: '0.8rem',
                        margin: '0 0 12px 0'
                    }}>
                        Cada ticket equivale a <strong style={{color: '#FFFA2F'}}>50 Bs.</strong>
                    </p>

                    {/* Ticket Cards - Mobile */}
                    <div style={{
                        display: 'flex',
                        gap: '6px',
                        marginBottom: '8px',
                        width: '100%',
                    }}>
                        <TicketCard
                            num="1" label="Ticket" price="Bs. 50"
                            selected={tickets === 1 && !showAmount}
                            onClick={() => selectTickets(1)}
                            mobile={true}
                        />
                        <TicketCard
                            num="3" label="Tickets" price="Bs. 150"
                            selected={tickets === 3 && !showAmount}
                            onClick={() => selectTickets(3)}
                            mobile={true}
                        />
                        <TicketCard
                            num="5" label="Tickets" price="Bs. 250"
                            selected={tickets === 5 && !showAmount}
                            onClick={() => selectTickets(5)}
                            mobile={true}
                        />
                        <TicketCard
                            num="+" label="Tickets" price="Tú eliges"
                            selected={showAmount}
                            isCustom={true}
                            onClick={() => {
                                setShowAmount(true);
                                setAmount(250);
                                setTickets(5);
                            }}
                            mobile={true}
                        />
                    </div>

                    <p style={{
                        color: '#ffffff',
                        fontSize: '0.65rem',
                        margin: '0 0 12px 0'
                    }}>
                        * Por cada <strong>Bs 50</strong> donados recibes una oportunidad más para participar en el <strong>SORTEO.</strong>
                    </p>

                    {showAmount && (
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            marginBottom: '12px'
                        }}>
                            <TextField
                                value={tickets || ''}
                                onChange={handleChange}
                                onKeyDown={handleChange}
                                placeholder="Nº tickets"
                                variant="outlined"
                                size="small"
                                sx={{
                                    width: '100px',
                                    '& .MuiOutlinedInput-root': {
                                        color: '#fff',
                                        backgroundColor: 'rgba(0,0,0,0.3)',
                                        height: '36px',
                                        '& fieldset': {borderColor: 'rgba(255,255,255,0.5)'},
                                        '&:hover fieldset': {borderColor: '#fff'},
                                        '&.Mui-focused fieldset': {borderColor: '#FFFA2F'},
                                    },
                                    '& .MuiInputBase-input': {color: '#fff', fontSize: '0.85rem'}
                                }}
                            />
                            <span style={{color: '#fff', fontSize: '0.8rem'}}>
                                ticket{tickets !== 1 ? 's' : ''} = <strong style={{color: '#FFFA2F'}}>Bs. {amount}</strong>
                            </span>
                        </div>
                    )}

                    {/* Dona Ahora - centered */}
                    <div id="dona-ahora-btn" style={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                        marginBottom: '12px'
                    }}>
                        <button
                            onClick={donate}
                            style={{
                                backgroundColor: '#FFFA2F',
                                color: '#000',
                                border: 'none',
                                borderRadius: '8px',
                                padding: '12px 28px',
                                fontSize: '1.2rem',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                textTransform: 'uppercase',
                            }}
                            className="font-face-UniversBold"
                        >
                            DONA AHORA
                        </button>
                    </div>

                    {error !== "" && (
                        <div style={{
                            background: "#000",
                            fontSize: "0.8rem",
                            fontWeight: 600,
                            textAlign: "center",
                            color: "#fff",
                            padding: '6px 12px',
                            borderRadius: 5,
                            marginBottom: '10px',
                            display: 'inline-block'
                        }}>
                            <WarningAmberIcon sx={{fontSize: "1.1rem", marginRight: 0.5, verticalAlign: 'middle'}}/>
                            {error}
                        </div>
                    )}

                    {/* Con tu donación - mobile */}
                    <div style={{
                        border: '1px solid rgba(255,255,255,0.3)',
                        borderRadius: '10px',
                        padding: '10px 12px',
                    }}>
                        <p style={{
                            color: '#fff',
                            fontSize: '0.75rem',
                            fontWeight: 'bold',
                            margin: '0 0 6px 0'
                        }} className="font-face-UniversBold">
                            CON TU DONACIÓN:
                        </p>
                        <div style={{display: 'flex', alignItems: 'flex-start', gap: '6px', marginBottom: '5px'}}>
                            <img src={iconSmile} alt="" style={{width: '16px', flexShrink: 0, marginTop: '1px'}}/>
                            <span style={{color: '#fff', fontSize: '0.7rem', lineHeight: 1.3}}>
                                Cambias la vida de miles de niñas y niños y como agradecimiento por tu solidaridad,
                            </span>
                        </div>
                        <div style={{display: 'flex', alignItems: 'flex-start', gap: '6px'}}>
                            <img src={iconTshirt} alt="" style={{width: '16px', flexShrink: 0, marginTop: '1px'}}/>
                            <span style={{color: '#fff', fontSize: '0.7rem', lineHeight: 1.3}}>
                                Participas del <strong style={{color: '#29ABE2'}}>SORTEO</strong> de una polera oficial del FC Barcelona firmada por Lionel Messi. <em>Incluye el certificado de autenticidad.</em>
                            </span>
                        </div>
                    </div>

                    {/* Bottom bar */}
                    <div style={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        backgroundColor: 'rgba(0,0,0,0.55)',
                        padding: '8px 14px',
                        textAlign: 'center'
                    }}>
                        <p style={{
                            color: '#fff',
                            fontSize: '0.65rem',
                            margin: 0,
                            lineHeight: 1.3
                        }}>
                            El sorteo se realizará en la Teletón de UNICEF el <strong style={{color: '#FFFA2F'}}>domingo 20 de septiembre</strong> que será transmitido a nivel nacional por Red Uno.
                        </p>
                    </div>
                </section>
            )}
        </>
    );
}

LaPoleraDeMessi.propTypes = {};

export default LaPoleraDeMessi;
